const Pagos = () => {

  return (
    <div className="m-auto md:w-[80%]">
      <div className="grid grid-cols-2 gap-2">
        <div className="py-4">
          <span className="text-primary font-bold text-xl mb-4 block">Pagos y cobros</span>
          <a className="mb-4 border-t-0 border-e-0 border-s-0 border-b" href="/ingresos">
            <div>
              <span className="block font-bold">Tus pagos</span>
              <span>Llevá un registro de todos los pagos y reembolsos.</span>
            </div>

            <label className="font-bold cursor-pointer bg-primary block w-full text-white rounded-md py-2 text-center">
              Administrá los pagos
              <button className="hidden"></button>
            </label>
          </a>
          <hr />
          <div className="mb-4 border-t-0 border-e-0 border-s-0 border-b hidden">
            <div>
              <span className="block font-bold">Formas de pago</span>
              <span>Agregá una forma de pago a través de nuestro sistema de pago seguro y empezá a planear tu próximo viaje.</span>
            </div>

            <label className="font-bold cursor-pointer bg-primary block w-full text-white rounded-md py-2 text-center">
              Agregá una forma de pago
              <button className="hidden"></button>
            </label>
          </div>
          <hr />
          
          <div className="mb-4 border-t-0 border-e-0 border-s-0 border-b">
            <div>
              <span className="block font-bold">Formas de cobro</span>
              <span>Podes usar un métodos de cobro o mas. Para administrar los metodos de cobro o asignar un contribuyente, usá el menú para editar en cada caso.</span>
            </div>

            <a className="font-bold cursor-pointer bg-primary block w-full text-white rounded-md py-2 text-center" href="/cobros">
              Agregá una forma de cobro
            </a>
          </div>


        </div>
        <div></div>
      </div>
    </div>
  )
}

export default Pagos